import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {UrlBuilder} from "../url-builder/url.builder";
import {AiRawList} from "./AiRawList";

@Injectable({
  providedIn: 'root'
})
export class AnalogInRawValueDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }


  GetData(): Observable<AiRawList> {
    this.uiUrl = this.url.GetAnalogInRawValueUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<AiRawList>(this.uiUrl);
  }

}


